<template>
  <section class="form__content">
    <h3>7. {{ $t('notaBene.title') }}</h3>
    <div v-html="content" class="form__content"/>
  </section>
</template>

<script>
export default {
  name: 'NotaBene',

  props: {
    content: {
      required: true,
    },
    muiAuthorization: {
      required: false,
      default: false,
    },
    mui: {
      required: false,
      default: false,
    },
  },
}
</script>
